import { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaMosque, FaHandsHelping, FaGraduationCap, FaHeartbeat, FaUsers, FaHome, FaHandHoldingUsd } from "react-icons/fa";
import { MdOutlineVolunteerActivism } from "react-icons/md";
import { IoChevronDown } from "react-icons/io5";

const kategoriList = [
  { id: 1, name: "Keagamaan", icon: FaMosque },
  { id: 2, name: "Bencana Alam", icon: MdOutlineVolunteerActivism },
  { id: 3, name: "Kemanusiaan", icon: FaHandsHelping },
  { id: 4, name: "Pendidikan", icon: FaGraduationCap },
  { id: 5, name: "Kesehatan", icon: FaHeartbeat },
  { id: 6, name: "Kegiatan Sosial", icon: FaUsers },
  { id: 7, name: "Wakaf", icon: FaHome },
  { id: 8, name: "Zakat", icon: FaHandHoldingUsd },
];

const RekomendasiApp = () => {
  const [selectedKategori, setSelectedKategori] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const filteredKategori = selectedKategori ? kategoriList.filter((k) => k.name === selectedKategori) : kategoriList;

  return (
    <section
      className="relative w-full overflow-hidden -mt-12
     md:-mt-12">
      <div
        className="relative max-w-[1440px] mx-auto bg-[#f5f8f8]
        rounded-t-[40px] md:rounded-t-[70px]
        px-4 py-6 md:px-10 md:py-10 overflow-hidden">
        <div className="relative z-10">
          {/* BADGE */}{" "}
          <div>
            <div className="flex justify-center items-center mb-2 text-2xl md:text-3xl gap-2 text-primary2 ">
              <div className="font-semibold tracking-wide  ">KATEGORI DONASI</div>
              {/* 
            <IoFlashOutline size={30} /> */}
            </div>
            <div className="flex justify-center mb-6">
              <div className="bg-secondary w-28 h-2 rounded-full "></div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
            {/* ================= SIDEBAR ================= */}
            {/* <aside className="md:col-span-3">
              <div className="bg-gradient-to-b from-[#d5ecfa] to-transparent rounded-3xl p-4 md:p-5">
           
                <button onClick={() => setIsOpen(!isOpen)} className="md:hidden w-full flex justify-between items-center font-semibold text-primary2 text-lg">
                  Kategori
                  <IoChevronDown className={`transition ${isOpen ? "rotate-180" : ""}`} />
                </button>

              
                <div className="hidden md:block text-center text-primary2 text-xl font-semibold mb-4 ">Kategori</div>

                <div className="max-h-[250px] overflow-y-auto">
                  <ul className={`space-y-2 mt-4 md:mt-0 ${isOpen ? "block" : "hidden"} md:block`}>
                    <li>
                      <button
                        onClick={() => setSelectedKategori(null)}
                        className={`w-full text-left px-4 py-2 rounded-lg font-semibold transition ${selectedKategori === null ? "bg-primary2 text-white" : "text-gray-700 hover:bg-blue-100"}`}>
                        Semua
                      </button>
                    </li>

                    {kategoriList.map((item, index) => (
                      <li key={index}>
                        <button
                          onClick={() => setSelectedKategori(item.name)}
                          className={`w-full text-left px-4 py-2 rounded-lg font-semibold transition ${selectedKategori === item.name ? "bg-primary2 text-white" : "text-gray-700 hover:bg-blue-100"}`}>
                          {item.name.toUpperCase()}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </aside> */}

            {/* ================= CONTENT ================= */}
            <div className="md:col-span-9">
              <div className="grid grid-cols-4 sm:grid-cols-4 lg:grid-cols-4 gap-6">
                {filteredKategori.map((item, index) => {
                  const Icon = item.icon;

                  return (
                    <NavLink
                      key={index}
                      to={`/donasi?category=${item.id}`}
                      className="group md:bg-white rounded-2xl md:p-6 text-center
                      md:shadow hover:-translate-y-1 hover:shadow-lg
                      transition-all duration-300">
                      <div className="flex justify-center mb-4">
                        <div
                          className="w-16 h-16 rounded-xl flex items-center justify-center
                          bg-gradient-to-br from-green-300 to-primary2
                          shadow-md">
                          <Icon className="text-white text-2xl" />
                        </div>
                      </div>

                      <p className="text-xs md:text-sm font-semibold text-gray-700">{item.name}</p>
                    </NavLink>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RekomendasiApp;
